import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 100%;
  background: #ffffff;
  border: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 8px 8px 8px 16px;
  margin-bottom: 8px;
`;

export const Country = styled.div`
  display: flex;
  margin-right: auto;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
`;

export const ControllersWithErrorWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Controllers = styled.div`
  display: flex;
  gap: 16px;
`;

export const ErrorWrap = styled.div`
  position: absolute;
  bottom: -30px;
  left: 0;
  display: flex;
  justify-content: center;
  gap: 4px;
  margin: 4px 0;

  img,
  svg {
    height: 16px;
    min-width: 16px;
    max-width: 16px;
  }
`;

export const ErrorText = styled.span`
  color: ${Palette.Red._700};
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-left: 3px;
`;
